export default {
  UPLOAD: 'Upload',
  EXISTING_TRACKS: 'Existing tracks',
  MY_IMAGES: 'My Images',
  UNSPLASH: 'Unsplash',
  GIPHY: 'Giphy',
  WIKIMEDIA_COMMONS: 'Wikimedia Commons',
}
